'use client'

import { SOURCING_SCRIPT_URL } from '@/constants/assets'

import Script from 'next/script'
import type React from 'react'

interface SuppliersLayoutProps {
  children: React.ReactNode
}

export default function SuppliersLayout({ children }: SuppliersLayoutProps) {
  return (
    <>
      <Script src={SOURCING_SCRIPT_URL} />
      {children}
    </>
  )
}
